"use client";
import * as React from "react";
const SvgUnfoldLessRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 10 17", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M.9 16.1c.42.41 1.08.41 1.5 0L5 13.5l2.6 2.6a1.05 1.05 0 1 0 1.49-1.49l-3.34-3.34a1.05 1.05 0 0 0-1.49 0L.92 14.61a1.04 1.04 0 0 0-.01 1.49ZM9.1.71a1.05 1.05 0 0 0-1.5 0L5 3.32 2.4.72a1.05 1.05 0 0 0-1.48 0 1.06 1.06 0 0 0 0 1.5l3.34 3.34a1.05 1.05 0 0 0 1.48 0l3.34-3.34a1.05 1.05 0 0 0 .01-1.5Z" }));
export {
  SvgUnfoldLessRound as default
};
